import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig as baseAppConfig } from './app/app.i18n.config';
import { AppComponent } from './app/app.component';
import 'moment/locale/zh-tw';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { ConfigLoaderService } from './app/shared/services/config-loader.service';

function initializeApp(configLoader: ConfigLoaderService) {
  return () => {
    console.log('APP_INITIALIZER: 開始載入設定檔');
    return configLoader.load().then(() => {
      console.log('APP_INITIALIZER: 設定檔載入完成');
    });
  };
}

const appConfig: ApplicationConfig = {
  ...baseAppConfig,
  providers: [
    ...(baseAppConfig.providers ?? []),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigLoaderService],
      multi: true,
    },
  ],
};

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
